import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/opt/render/project/src/node_modules/.pnpm/gatsby-theme-docz@2.3.1_@babel+core@7.11.1_@types+node@24.7.0_docz@2.4.0_@babel+core@7._04842b0c5656885ffb9b2f355e30df2b/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "license"
    }}>{`License`}</h1>
    <p>{`Checks for and inserts the Kuali copyright header on source files. Implementation is in `}<inlineCode parentName="p">{`scripts/license/index.js`}</inlineCode>{`.`}</p>
    <h2 {...{
      "id": "usage"
    }}>{`Usage`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`# Check every supported source file has a current header
node scripts/license --check

# Write headers into every file that's missing one (or update outdated years)
node scripts/license --write

# Check or write a single file
node scripts/license --check path/to/file
node scripts/license --write path/to/file
`}</code></pre>
    <p>{`Supported extensions: `}<inlineCode parentName="p">{`.js`}</inlineCode>{`, `}<inlineCode parentName="p">{`.jsx`}</inlineCode>{`, `}<inlineCode parentName="p">{`.ts`}</inlineCode>{`, `}<inlineCode parentName="p">{`.tsx`}</inlineCode>{`, `}<inlineCode parentName="p">{`.css`}</inlineCode>{`, `}<inlineCode parentName="p">{`.mjs`}</inlineCode>{`. The header year range runs from 2017 to the current UTC year.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      